import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Label } from "../components/ui/label";

export const ProgramSelect = ({ programs, value, onChange }) => (
  <div className="space-y-1.5" data-testid="program-field">
    <Label className="text-sm font-semibold text-slate-700">Program / satnica</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid="select-program" className="h-auto min-h-12 rounded-xl text-left whitespace-normal py-2 [&>span]:line-clamp-none">
        <SelectValue placeholder="Odaberite program" />
      </SelectTrigger>
      <SelectContent position="popper" className="w-[var(--radix-select-trigger-width)] max-w-[92vw]">
        {programs.map((p, i) => (
          <SelectItem key={p} value={p} className="whitespace-normal leading-snug py-2" data-testid={`program-option-${i}`}>
            {p}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
    <p className="text-xs text-slate-400 leading-snug">
      Ovaj predmet ima više službenih programa s različitim ishodima. Odaberite onaj po kojem radite.
    </p>
  </div>
);
